import _ from 'underscore';

export const getAggregationRestrictions = (rawSchema) => {
  const output = {};
  if (!rawSchema.AggregationExclusion) {
    return output;
  }
  _.forEach(rawSchema.AggregationExclusion, (node, timeGrain) => {
    if (_.isArray(node)) {
      _.forEach(node, (columnKey) => {
        if (!output[columnKey]) {
          output[columnKey] = [];
        }
        output[columnKey].push(timeGrain);
      });
    }
  });
  return output;
};

